<template>
  <div :class="['answer-input-box', { flexCenter: center }]">
    <div
      :class="[
        'input-item',
        {
          success: blankType === 'success',
        },
        {
          error: blankType === 'error',
        },
      ]"
      v-for="(item, index) in textArr"
      :key="index"
      @click="clickItem(index, item)"
    >
      <div class="input-item-text" v-if="textType === 'string'">
        {{ item.text }}
      </div>
      <PhoneticText
        v-else-if="item.text"
        :showPinyin="true"
        :originData="item.text"
        :baseStyles="baseStyles"
      ></PhoneticText>
    </div>
  </div>
</template>

<script>
import PhoneticText from '@/components/ui/phoneticText'
export default {
  name: 'AnswerInputBox',
  components: {
    PhoneticText,
  },
  props: {
    textType: {
      type: String,
      default: 'phonetic', // phonetic拼音，string字符串
    },
    textArr: {
      type: Array,
      default: () => [],
    },
    blankType: {
      type: String,
      default: '',
    },
    center: {
      type: Boolean,
      default: false,
    },
    baseStyles: {
      type: Object,
      default: () => {
        return {
          // 拼音文本字体大小
          pinyinFontSize: '12px',
          // 拼音文本 行高
          pinyinLineHeight: '14px',
          // 拼音文本字体大小
          hzFontSize: '18px',
          // 汉字文本 行高
          hzLineHeight: '20px',
          // 行文 间距(下方间距)
          writingSpacing: '0',
          // 显示居中
          justifyContent: 'center',
        }
      },
    },
  },
  methods: {
    clickItem(inputIndex, item) {
      if (item.text) {
        this.$emit('remove', {
          inputIndex,
          answerIndex: item.answerIndex,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.answer-input-box {
  // width: 840px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;

  &.flexCenter {
    justify-content: center;

    .input-item {
      margin: 10px 10px;
      border: 1px solid transparent;
    }
  }

  .input-item {
    cursor: pointer;
    min-width: 80px;
    height: 48px;
    margin: 10px;
    padding: 0 10px;
    background: rgba(246, 247, 252, 1);
    opacity: 0.9;
    border: 1px solid rgba(207, 213, 222, 1);
    border-radius: 8px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    &-text {
      margin-top: -5px;
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    &.success {
      background-color: rgba(230, 249, 245, 1);
      border-color: rgba(9, 203, 160, 1);

      .input-item-text {
        color: #09cba0;
      }

      ::v-deep p.pinyin span {
        color: #09cba0 !important;
      }
      ::v-deep p.hz span {
        color: #09cba0 !important;
      }
    }
    &.error {
      background-color: rgba(254, 244, 235, 1);
      border-color: #FC5A5A;

      .input-item-text {
        color: #FC5A5A;
      }

      ::v-deep p.pinyin span {
        color: #FC5A5A !important;
      }
      ::v-deep p.hz span {
        color: #FC5A5A !important;
      }
    }
  }
}
</style>
